/* ==========================================================
   ParentRecord™ — Pagina Prodotto "Court Week Calm Protocol"
   File: assets/parentrecord-pdf-courtweek.js
   Stile e comportamento derivati da parentrecord-landing.js

   NOTE VALUTA:
   Il pulsante CTA hero mostra il prezzo già localizzato da
   Shopify lato server (filtro Liquid "money", che rispetta
   Shopify Markets / multi-currency in automatico).
   Il drawer carrello invece riceve i prezzi via /cart.js,
   che Shopify restituisce già nella valuta di presentazione
   del visitatore (cart.currency). formatMoney qui sotto usa
   Intl.NumberFormat con quella valuta — nessuna API esterna,
   nessun tasso di cambio gestito a mano.
   ========================================================== */

(function () {
  'use strict';

  /* ── Helpers ─────────────────────────────────────────────── */
  var cartCurrency = 'USD'; // aggiornato al primo fetch di /cart.js

  function formatMoney(cents) {
    var amount = cents / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: cartCurrency,
        currencyDisplay: 'narrowSymbol'
      }).format(amount);
    } catch (e) {
      /* Fallback se il browser non supporta narrowSymbol o la currency è invalida */
      return amount.toFixed(2) + ' ' + cartCurrency;
    }
  }

  /* ── Drawer state ────────────────────────────────────────── */
  var drawer       = document.getElementById('prDrawer');
  var overlay      = document.getElementById('prDrawerOverlay');
  var drawerBody   = document.getElementById('prDrawerBody');
  var drawerFooter = document.getElementById('prDrawerFooter');
  var drawerSub    = document.getElementById('prDrawerSubtotal');
  var closeBtn     = document.getElementById('prDrawerClose');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('pr-open');
    overlay.classList.add('pr-open');
    document.body.classList.add('pr-drawer-open');
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('pr-open');
    overlay.classList.remove('pr-open');
    document.body.classList.remove('pr-drawer-open');
  }

  if (closeBtn)  closeBtn.addEventListener('click', closeDrawer);
  if (overlay)   overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ── Render cart items ───────────────────────────────────── */
  function renderCart(cart) {
    if (!drawerBody) return;

    if (!cart.items || cart.items.length === 0) {
      drawerBody.innerHTML = '<div class="pr-drawer-empty">Your cart is empty.<br>Add the bundle to get started.</div>';
      if (drawerFooter) drawerFooter.style.display = 'none';
      updateCartTrigger(cart);
      return;
    }

    var html = '';
    cart.items.forEach(function (item) {
      var imgHtml = item.image
        ? '<a href="/" class="pr-drawer-item-img-link"><img class="pr-drawer-item-img" src="' + item.image + '" alt="' + item.title + '" loading="lazy"></a>'
        : '<div class="pr-drawer-item-img-ph">No image</div>';

      var originalPrice = item.original_price !== item.final_price
        ? '<span class="pr-drawer-item-price-old">' + formatMoney(item.original_price) + '</span>'
        : '';

      html += '<div class="pr-drawer-item" data-key="' + item.key + '">';
      html += imgHtml;
      html += '<div class="pr-drawer-item-info">';
      html += '<div class="pr-drawer-item-title"><a class="pr-drawer-item-title-link" href="/">' + item.product_title + '</a></div>';
      html += '<div class="pr-drawer-item-price">' + originalPrice + formatMoney(item.final_price) + '</div>';
      html += '<div class="pr-drawer-qty-row">';
      html += '<div class="pr-drawer-qty">';
      html += '<button class="pr-qty-minus" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">−</button>';
      html += '<span>' + item.quantity + '</span>';
      html += '<button class="pr-qty-plus" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>';
      html += '</div>';
      html += '<button class="pr-drawer-remove" data-key="' + item.key + '" data-qty="0">Remove</button>';
      html += '</div>';
      html += '</div>';
      html += '</div>';
    });

    drawerBody.innerHTML = html;

    if (drawerSub)    drawerSub.textContent = formatMoney(cart.total_price);
    if (drawerFooter) drawerFooter.style.display = 'block';
    updateCartTrigger(cart);

    /* Qty / remove buttons */
    drawerBody.querySelectorAll('.pr-qty-minus, .pr-qty-plus, .pr-drawer-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-key');
        var qty = parseInt(btn.getAttribute('data-qty'), 10);
        updateItem(key, qty);
      });
    });
  }

  /* ── Fetch current cart ──────────────────────────────────── */
  function fetchCart(callback) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && cart.currency) cartCurrency = cart.currency;
        callback(cart);
      })
      .catch(function () {
        if (drawerBody) drawerBody.innerHTML = '<div class="pr-drawer-empty">Could not load cart. <a href="/cart">View cart</a></div>';
      });
  }

  /* ── Update item quantity ────────────────────────────────── */
  function updateItem(key, quantity) {
    if (drawerBody) drawerBody.style.opacity = '0.5';
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      if (cart && cart.currency) cartCurrency = cart.currency;
      if (drawerBody) drawerBody.style.opacity = '1';
      renderCart(cart);
    })
    .catch(function () {
      if (drawerBody) drawerBody.style.opacity = '1';
    });
  }

  /* ── Add to cart + open drawer ───────────────────────────── */
  function addToCartAndOpen(variantId, btn) {
    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    if (drawerBody) drawerBody.innerHTML = '<div class="pr-drawer-loading">Loading…</div>';
    if (drawerFooter) drawerFooter.style.display = 'none';
    openDrawer();

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Add failed');
      return r.json();
    })
    .then(function () {
      fetchCart(renderCart);
      btn.textContent = '✓ Added!';
      btn.style.background = '#1F8A4C';
      setTimeout(function () {
        btn.textContent = originalText;
        btn.style.background = '';
        btn.disabled = false;
      }, 2000);
    })
    .catch(function () {
      closeDrawer();
      btn.textContent = originalText;
      btn.disabled = false;
      window.location.href = '/cart/' + variantId + ':1?redirect=/cart';
    });
  }

  /* ── Cart Trigger (floating button) ─────────────────────── */
  function updateCartTrigger(cart) {
    var trigger = document.getElementById('prCartTrigger');
    var badge   = document.getElementById('prCartTriggerBadge');
    if (!trigger) return;
    var count = (cart && cart.item_count) ? cart.item_count : 0;
    if (count > 0) {
      trigger.style.display = 'flex';
      if (badge) badge.textContent = count;
    } else {
      trigger.style.display = 'none';
    }
  }

  function initCartTrigger() {
    var trigger = document.getElementById('prCartTrigger');
    if (!trigger) return;
    trigger.addEventListener('click', function () {
      fetchCart(function (cart) {
        renderCart(cart);
        openDrawer();
      });
    });
    fetchCart(function (cart) {
      updateCartTrigger(cart);
    });
  }

  /* ── Init CTA buttons ────────────────────────────────────── */
  function initCartButtons() {
    document.querySelectorAll('.pr-btn[data-variant-id]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        addToCartAndOpen(btn.getAttribute('data-variant-id'), btn);
      });
    });
  }

  /* ── Testimonials Carousel ───────────────────────────────── */
  function initCarousel() {
    var track   = document.querySelector('.pr-t-track');
    var cards   = document.querySelectorAll('.pr-t-card');
    var prevBtn = document.querySelector('.pr-t-arrow.pr-t-prev');
    var nextBtn = document.querySelector('.pr-t-arrow.pr-t-next');

    if (!track || !cards.length || !prevBtn || !nextBtn) return;

    var index = 0;

    function visibleCount() { return window.innerWidth > 820 ? 2 : 1; }
    function maxIndex()     { return Math.max(0, cards.length - visibleCount()); }
    function update() {
      var gap       = 24;
      var cardWidth = cards[0].getBoundingClientRect().width;
      track.style.transform = 'translateX(-' + index * (cardWidth + gap) + 'px)';
      prevBtn.disabled = index <= 0;
      nextBtn.disabled = index >= maxIndex();
    }

    prevBtn.addEventListener('click', function () { if (index > 0)             { index--; update(); } });
    nextBtn.addEventListener('click', function () { if (index < maxIndex())    { index++; update(); } });
    window.addEventListener('resize', function () { if (index > maxIndex()) index = maxIndex(); update(); });
    update();
  }

  /* ── Smooth anchor scrolling ─────────────────────────────── */
  function initSmoothScroll() {
    document.querySelectorAll('.pr-landing a[href^="#"]').forEach(function (anchor) {
      anchor.addEventListener('click', function (e) {
        var target = document.getElementById(this.getAttribute('href').slice(1));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ── Fade-in on scroll ───────────────────────────────────── */
  function initFadeIn() {
    if (!window.IntersectionObserver) return;
    var style = document.createElement('style');
    style.textContent = [
      '.pr-fade-target { opacity:0; transform:translateY(24px); transition:opacity .55s ease,transform .55s ease; }',
      '.pr-fade-target.pr-visible { opacity:1; transform:translateY(0); }'
    ].join('');
    document.head.appendChild(style);

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('pr-visible'); observer.unobserve(entry.target); }
      });
    }, { threshold: 0.08 });

    document.querySelectorAll('.pr-landing section').forEach(function (s) {
      s.classList.add('pr-fade-target');
      observer.observe(s);
    });

    var hero = document.querySelector('.pr-hero');
    if (hero) { hero.classList.add('pr-visible'); hero.style.opacity = '1'; hero.style.transform = 'none'; }
  }

  /* ── Social Proof Popup ──────────────────────────────────── */
  function initSocialPopup() {
    var popup     = document.getElementById('prPopup');
    var popupName = document.getElementById('prPopupName');
    var popupTime = document.getElementById('prPopupTime');
    var popupAvatar = document.getElementById('prPopupAvatar');
    var popupClose  = document.getElementById('prPopupClose');

    if (!popup) return;

    var names = [
      'Ashley M.', 'Jennifer R.', 'Sarah K.', 'Amanda L.', 'Jessica T.',
      'Stephanie H.', 'Michelle W.', 'Lisa B.', 'Angela C.', 'Melissa D.',
      'Lauren P.', 'Rachel N.', 'Megan S.', 'Christina F.', 'Brittany G.',
      'Nicole A.', 'Heather J.', 'Amber V.', 'Tiffany O.', 'Danielle E.'
    ];

    var states = [
      'California', 'Texas', 'Florida', 'New York', 'Ohio',
      'Georgia', 'Pennsylvania', 'Illinois', 'Arizona', 'Colorado',
      'Michigan', 'Virginia', 'Washington', 'Tennessee', 'Oregon'
    ];

    /* Soft pastel-on-dark avatar colors */
    var colors = [
      '#1755B8', '#0E6655', '#7D3C98', '#B03A2E',
      '#1A5276', '#117A65', '#6E2F8F', '#935116'
    ];

    var lastIndex = -1;
    var hideTimer = null;
    var nextTimer = null;
    var dismissed = false;

    function rand(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    function randomTime() {
      var mins = rand(1, 47);
      if (mins === 1) return 'just now';
      if (mins < 60) return mins + ' minutes ago';
      var hrs = Math.floor(mins / 60);
      return hrs === 1 ? '1 hour ago' : hrs + ' hours ago';
    }

    function pickIndex() {
      var i;
      do { i = rand(0, names.length - 1); } while (i === lastIndex);
      lastIndex = i;
      return i;
    }

    function showPopup() {
      if (dismissed) return;

      var i      = pickIndex();
      var name   = names[i];
      var state  = states[rand(0, states.length - 1)];
      var color  = colors[rand(0, colors.length - 1)];
      var initials = name.charAt(0);

      popupAvatar.textContent    = initials;
      popupAvatar.style.background = color;
      popupName.textContent      = name + ' from ' + state;
      popupTime.textContent      = randomTime();

      popup.classList.remove('pr-popup-hiding');
      popup.classList.add('pr-popup-visible');

      /* Hide after 3s */
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () {
        hidePopup();
      }, 3000);
    }

    function hidePopup() {
      popup.classList.add('pr-popup-hiding');
      popup.classList.remove('pr-popup-visible');

      /* Schedule next appearance: random between 8 and 20 seconds */
      clearTimeout(nextTimer);
      nextTimer = setTimeout(function () {
        popup.classList.remove('pr-popup-hiding');
        showPopup();
      }, rand(8000, 20000));
    }

    /* Close button dismisses for the session */
    if (popupClose) {
      popupClose.addEventListener('click', function () {
        dismissed = true;
        clearTimeout(hideTimer);
        clearTimeout(nextTimer);
        popup.classList.add('pr-popup-hiding');
        popup.classList.remove('pr-popup-visible');
      });
    }

    /* First appearance after 4 seconds */
    setTimeout(showPopup, 4000);
  }

  /* ── Init ────────────────────────────────────────────────── */
  function init() {
    initCartTrigger();
    initCartButtons();
    initCarousel();
    initSmoothScroll();
    initFadeIn();
    initSocialPopup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
